interface TeamManagerLabelProps {
  /** Resolved manager display name for a team (see `useManagerNames`). */
  label: string | undefined;
}

/** Small muted label shown next to a team name — the real person behind it. */
export function TeamManagerLabel({ label }: TeamManagerLabelProps) {
  if (!label) return null;
  return <span className="team-name__manager"> ({label})</span>;
}
